module.exports = __webpack_public_path__ + "img/Want Av Sight 03.872ffc15.png";